import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiFilter',
  pure: false,
})
@Injectable()
export class SearchPipe implements PipeTransform {
  transform(items: any[], term: string): any {
    if (!term) {
      return items;
    }

    return items.filter(function (item) {
      for (let property in item) {
        if (item[property] === null) {
          continue;
        }
        if (item[property].toString().toLowerCase().includes(term.toLowerCase())) {
          return true;
        }
      }

      return false;
    });
  }
}
